module.exports = {
	"Search the video": "Rechercher la vidéo",
	"Explore": "Parcourir",
	"Print": "Imprimer",
	"Download": "Télécharger",
	"Share": "Partager",
	"Settings": "Paramètres",
	"Language": "Langue",
	"Interface Language": "Langue de l'interface",
	"Transcript / Captions Language": "Langue de la transcription / des sous-titres",
	"Transcript Language": "Langue de la transcription",
	"Captions Language": "Langue des sous-titres",
	"Show Transcript": "Afficher la transcription",
	"Show Captions": "Afficher les sous-titres",
	"Show Heatmap": "Afficher la heat map",
	"Show Speakers in Transcript": "Afficher les orateurs dans la transcription",
	"Keyword": "Mot-clé",
	"Keywords": "Mots-clés",
	"Topic": "Sujet",
	"Topics": "Sujets",
	"Speaker": "Orateur",
	"Speakers": "Orateurs",
	"Transcript": "Transcription",
	"Previous": "Précédent",
	"Next": "Suivant",
	"Clear": "Effacer",
	"No results found": "Aucun résultat trouvé",
	"try another search or explore": "effectuer une autre recherche ou exploration",
	"Share Search": "Recherche partagée",
	"Share Time": "Partage de temps",
	"There is no transcript available in the selected language.": "La traduction n'est pas disponible dans cette langue.",
	"Show {{count}} more": "Afficher {{count}} plus",
	"Show {{count}} more_plural": "Afficher {{count}} plus"
};


//////////////////
// WEBPACK FOOTER
// ./locale/fr.json
// module id = ./locale/fr.json
// module chunks = 0 1